export const NotificationType = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warn",
  INFO: "info"
};
export const NotificationMessages = {
  UPLOAD: {
    SUCCESS: {
      title: "Proceso completado",
      text: (recordsCreated, existingCount) => `Se proces\xF3 el archivo correctamente. Registros creados: ${recordsCreated}, Registros existentes: ${existingCount}`
    },
    ERROR: {
      title: "Error",
      text: "No se pudo subir la plantilla. Por favor, intente nuevamente."
    }
  },
  DOWNLOAD: {
    ERROR: {
      title: "Error",
      text: "No se pudo descargar la plantilla. Por favor, intente nuevamente."
    }
  }
};
export const showNotification = (type, title, text) => {
  return {
    type,
    title,
    text
  };
};
export default NotificationType;
